import { APP_DEFAULT_LANGUAGE } from '~/core/constants'
import { EGuardEntityName, EPerformanceSummaryFlag, ITableColumn } from '~/core/models'
import { compactNumber, forecastPercentNumber } from '~/utils/index'

export const MARKET_CUB_COLUMNS: ITableColumn[] = [
  {
    name: 'mktCapFrom',
    key: 'mktCapFrom',
    isTotalColumn: true,
    guardEntityField: 'expected_impact_at_act', // TODO: Permission
    guardEntityName: EGuardEntityName.ADDL_PRED, // TODO: Permission
    i18nName: 'performance.winRatesByMarketCup.table.mktCapFrom',
    title: (v: number) => compactNumber(v, APP_DEFAULT_LANGUAGE),
  },
  {
    name: 'mktCapTo',
    key: 'mktCapTo',
    guardEntityField: 'expected_impact_at_act', // TODO: Permission
    guardEntityName: EGuardEntityName.ADDL_PRED, // TODO: Permission
    i18nName: 'performance.winRatesByMarketCup.table.mktCapTo',
    title: (v: number, summaryFlag: EPerformanceSummaryFlag) =>
      compactNumber(
        v,
        APP_DEFAULT_LANGUAGE,
        summaryFlag === EPerformanceSummaryFlag.SUMMARY_COLUMN
          ? ''
          : 'performance.numFromTo.greater'
      ),
  },
  {
    name: 'epsWeBeatThem',
    key: 'epsWeBeatThem',
    guardEntityField: 'expected_impact_at_act', // TODO: Permission
    guardEntityName: EGuardEntityName.ADDL_PRED, // TODO: Permission
    i18nName: 'performance.winRatesByMarketCup.table.epsWeBeatThem',
    title: (v: number) => forecastPercentNumber(v, 1),
    classes: { 'text-center': true },
  },
  {
    name: 'revWeBeatThem',
    key: 'revWeBeatThem',
    guardEntityField: 'expected_impact_at_act', // TODO: Permission
    guardEntityName: EGuardEntityName.ADDL_PRED, // TODO: Permission
    i18nName: 'performance.winRatesByMarketCup.table.revWeBeatThem',
    title: (v: number) => forecastPercentNumber(v, 1),
    classes: { 'text-center': true },
  },
  {
    name: 'epsErrorReduction',
    key: 'epsErrorReduction',
    guardEntityField: 'expected_impact_at_act', // TODO: Permission
    guardEntityName: EGuardEntityName.ADDL_PRED, // TODO: Permission
    i18nName: 'performance.winRatesByMarketCup.table.epsErrorReduction',
    title: (v: number) => forecastPercentNumber(v, 1),
    classes: { 'text-center': true },
  },
  {
    name: 'revErrorReduction',
    key: 'revErrorReduction',
    guardEntityField: 'expected_impact_at_act', // TODO: Permission
    guardEntityName: EGuardEntityName.ADDL_PRED, // TODO: Permission
    i18nName: 'performance.winRatesByMarketCup.table.revErrorReduction',
    title: (v: number) => forecastPercentNumber(v, 1),
    classes: { 'text-center': true },
  },
  {
    name: 'companyCount',
    key: 'companyCount',
    guardEntityField: 'expected_impact_at_act', // TODO: Permission
    guardEntityName: EGuardEntityName.ADDL_PRED, // TODO: Permission
    i18nName: 'performance.winRatesByMarketCup.table.companyCount',
    classes: { 'text-center': true, 'no-wrap': true },
  },
]
